module.exports = __webpack_public_path__ + "static/media/server.faadf3b5.svg";